// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import {
//   ShoppingBag,
//   Truck,
//   ShoppingCart,
//   Package,
//   Users,
//   UserPlus,
//   FilePlus,
//   PlusCircle,
// } from "lucide-react";
// import { Api } from "../Api/Api";

// export default function Dashboard() {
//   const [wholesaleTotal, setWholesaleTotal] = useState(0);
//   const [retailTotal, setRetailTotal] = useState(0);
//   const [productCount, setProductCount] = useState(0);
//   const [username, setUsername] = useState("");

//   const [products, setProducts] = useState([]);
//   const [lowStockProducts, setLowStockProducts] = useState([]);

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(`${Api}product/read.php`);
//       const data = Array.isArray(res.data) ? res.data : [res.data];
//       setProducts(data);
//       setProductCount(data.length);
//       console.log(data);

//       // 🔹 Check for low stock
//       const lowStock = data.filter((p) => parseInt(p.stock) < 5);
//       setLowStockProducts(lowStock);
//     } catch (err) {
//       console.error("Error fetching products:", err);
//     }
//   };

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser"));
//     if (currentUser && currentUser.username) {
//       setUsername(currentUser.username);
//     }
//   }, []);

//   const fetchAllBills = async () => {
//     try {
//       const res = await axios.get(`${Api}bills/get_all.php`);
//       const usageBills = res.data.filter((bill) => bill.type !== "deduction");
//       console.log("Fetched Bills:", usageBills);
//       const total = usageBills.reduce(
//         (sum, bill) => sum + parseFloat(bill.paid || 0),
//         0
//       );
//       setWholesaleTotal(total);
//     } catch (err) {
//       console.error("Failed to fetch wholesale bills", err);
//     }
//   };

//   const fetchOrders = async () => {
//     try {
//       const res = await axios.get(`${Api}retail/retail_get.php`);
//       const total = res.data.reduce(
//         (sum, order) => sum + parseFloat(order.paid_amount || 0),
//         0
//       );
//       setRetailTotal(total);
//     } catch (err) {
//       console.error("Error fetching retail orders:", err);
//     }
//   };

//   useEffect(() => {
//     fetchAllBills();
//     fetchOrders();
//     fetchProducts();
//   }, []);

//   const totalSales = wholesaleTotal + retailTotal;

//   // 🎨 Colors for each card
//   const cardColors = [
//     "bg-gradient-to-r from-green-600 to-green-800 text-white",
//     "bg-gradient-to-r from-orange-500 to-red-600 text-white",
//     "bg-gradient-to-r from-blue-600 to-cyan-700 text-white",
//     "bg-gradient-to-r from-purple-600 to-indigo-700 text-white",
//   ];

//   return (
//     <div className="min-h-screen p-6 md:p-3  bg-gray-50">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <header className="mb-10 text-center">
//           <h1 className="text-2xl font-extrabold text-gray-900 text-left">
//             Murugan Ayurvedhic CRM
//           </h1>
//           <p className="text-gray-600 mt-2 text-lg text-left">
//             {username ? `Hi ${username}, ` : ""}let's grow your business today
//             🚀
//           </p>
//         </header>

//         {/* Stats Overview */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
//           {/* Total Sales */}
//           <div
//             className={`${cardColors[0]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
//           >
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm opacity-80">Total Sales</p>
//                 <h3 className="text-3xl font-bold mt-2">
//                   ₹{totalSales.toFixed(2)}
//                 </h3>
//               </div>
//               <ShoppingBag className="w-10 h-10 opacity-90" />
//             </div>
//           </div>

//           {/* Wholesale Sales */}
//           <div
//             className={`${cardColors[1]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
//           >
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm opacity-80">Wholesale Sales</p>
//                 <h3 className="text-3xl font-bold mt-2">
//                   ₹{wholesaleTotal.toFixed(2)}
//                 </h3>
//               </div>
//               <Truck className="w-10 h-10 opacity-90" />
//             </div>
//           </div>

//           {/* Retail Sales */}
//           <div
//             className={`${cardColors[2]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
//           >
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm opacity-80">Retail Sales</p>
//                 <h3 className="text-3xl font-bold mt-2">
//                   ₹{retailTotal.toFixed(2)}
//                 </h3>
//               </div>
//               <ShoppingCart className="w-10 h-10 opacity-90" />
//             </div>
//           </div>

//           {/* Products */}
//           <div
//             className={`${cardColors[3]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
//           >
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm opacity-80">Products</p>
//                 <h3 className="text-3xl font-bold mt-2">{productCount}</h3>
//                 <p className="text-sm opacity-70">In inventory</p>
//               </div>
//               <Package className="w-10 h-10 opacity-90" />
//             </div>
//           </div>
//         </div>

//         {/* Low Stock Alert */}
//         {lowStockProducts.length > 0 && (
//           <div className="bg-gradient-to-r from-red-600 to-red-800 text-white rounded-2xl p-6 shadow-lg flex flex-col justify-between">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm opacity-80">Low Stock Alert</p>
//                 <ul className="mt-2 space-y-1 text-sm">
//                   {lowStockProducts.map((p) => (
//                     <li key={p.id}>
//                       ⚠️ {p.product}{" "}
//                       <span className="opacity-75">({p.category})</span> –{" "}
//                       {p.stock} left
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Quick Actions */}
//         <div className="mb-8 text-center">
//           <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-12">
//             Quick Actions
//           </h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 justify-center">
//             {[
//               {
//                 label: "Add Product",
//                 icon: <PlusCircle className="w-6 h-6" />,
//                 to: "/admin/wholesale",
//               },
//               {
//                 label: "New Wholesale Bill",
//                 icon: <FilePlus className="w-6 h-6" />,
//                 to: "/admin/billing",
//               },
//               {
//                 label: "New Retail Bill",
//                 icon: <ShoppingCart className="w-6 h-6" />,
//                 to: "/admin/retail",
//               },
//               {
//                 label: "Customer Bills",
//                 icon: <UserPlus className="w-6 h-6" />,
//                 to: "/admin/retaildetails",
//               },
//               {
//                 label: "Workers Bills",
//                 icon: <Users className="w-6 h-6" />,
//                 to: "/admin/workers-bills",
//               },
//             ].map((action, idx) => (
//               <Link
//                 key={idx}
//                 to={action.to}
//                 className="no-underline bg-white rounded-xl p-6 shadow-md border hover:shadow-lg transition flex flex-col items-center gap-3"
//               >
//                 <div className="bg-gray-100 p-4 rounded-full">
//                   {action.icon}
//                 </div>
//                 <span className="text-sm font-semibold text-gray-800">
//                   {action.label}
//                 </span>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  ShoppingBag,
  Truck,
  ShoppingCart,
  Package,
  Users,
  UserPlus,
  FilePlus,
  PlusCircle,
} from "lucide-react";
import { Api } from "../Api/Api";

export default function Dashboard() {
  const [wholesaleTotal, setWholesaleTotal] = useState(0);
  const [retailTotal, setRetailTotal] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [username, setUsername] = useState("");

  const [products, setProducts] = useState([]);
  const [lowStockProducts, setLowStockProducts] = useState([]);

  // Dynamic font hook
  const useFitText = (text) => {
    const ref = useRef();
    const [fontSize, setFontSize] = useState(32);

    useEffect(() => {
      const resize = () => {
        if (!ref.current) return;
        let currentSize = 32;
        const maxWidth = ref.current.offsetWidth;
        const span = document.createElement("span");
        span.style.visibility = "hidden";
        span.style.position = "absolute";
        span.style.whiteSpace = "nowrap";
        span.innerText = text;
        document.body.appendChild(span);

        while (span.offsetWidth > maxWidth && currentSize > 10) {
          currentSize -= 1;
          span.style.fontSize = currentSize + "px";
        }

        setFontSize(currentSize);
        document.body.removeChild(span);
      };

      resize();
      window.addEventListener("resize", resize);
      return () => window.removeEventListener("resize", resize);
    }, [text]);

    return [ref, fontSize];
  };

  // References for dynamic font sizes
  const [totalRef, totalFont] = useFitText(
    `₹${(wholesaleTotal + retailTotal).toFixed(2)}`
  );
  const [wholesaleRef, wholesaleFont] = useFitText(
    `₹${wholesaleTotal.toFixed(2)}`
  );
  const [retailRef, retailFont] = useFitText(`₹${retailTotal.toFixed(2)}`);
  const [productRef, productFont] = useFitText(`${productCount}`);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      const data = Array.isArray(res.data) ? res.data : [res.data];
      setProducts(data);
      setProductCount(data.length);

      const lowStock = data.filter((p) => parseInt(p.stock) < 5);
      setLowStockProducts(lowStock);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser && currentUser.username) {
      setUsername(currentUser.username);
    }
  }, []);

  const fetchAllBills = async () => {
    try {
      const res = await axios.get(`${Api}bills/get_all.php`);
      const usageBills = res.data.filter((bill) => bill.type !== "deduction");
      const total = usageBills.reduce(
        (sum, bill) => sum + parseFloat(bill.paid || 0),
        0
      );
      setWholesaleTotal(total);
    } catch (err) {
      console.error("Failed to fetch wholesale bills", err);
    }
  };

  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${Api}retail/retail_get.php`);
      const total = res.data.reduce(
        (sum, order) => sum + parseFloat(order.paid_amount || 0),
        0
      );
      setRetailTotal(total);
    } catch (err) {
      console.error("Error fetching retail orders:", err);
    }
  };

  useEffect(() => {
    fetchAllBills();
    fetchOrders();
    fetchProducts();
  }, []);

  const totalSales = wholesaleTotal + retailTotal;

  const cardColors = [
    "bg-gradient-to-r from-green-600 to-green-800 text-white",
    "bg-gradient-to-r from-orange-500 to-red-600 text-white",
    "bg-gradient-to-r from-blue-600 to-cyan-700 text-white",
    "bg-gradient-to-r from-purple-600 to-indigo-700 text-white",
  ];

  return (
    <div className="min-h-screen p-6 md:p-3  bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <header className="mb-10 text-left">
          <h1 className="text-2xl font-extrabold text-gray-900">
            Sri Murugan Ayurvedha CRM
          </h1>
          <p className="text-gray-600 mt-2 text-lg">
            {username ? `Hi ${username}, ` : ""}let's grow your business today
            🚀
          </p>
        </header>

        {/* Stats Overview */}
        {/* Stats Overview */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-12">
          {/* Total Sales */}
          <div
            className={`${cardColors[0]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm opacity-80">Total Sales</p>
                <h3
                  ref={totalRef}
                  style={{ fontSize: `${totalFont}px` }}
                  className="font-bold mt-2"
                >
                  ₹{totalSales.toFixed(2)}
                </h3>
              </div>
              <ShoppingBag className="w-10 h-10 opacity-90" />
            </div>
          </div>

          {/* Wholesale Sales */}
          <div
            className={`${cardColors[1]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm opacity-80">Wholesale Sales</p>
                <h3
                  ref={wholesaleRef}
                  style={{ fontSize: `${wholesaleFont}px` }}
                  className="font-bold mt-2"
                >
                  ₹{wholesaleTotal.toFixed(2)}
                </h3>
              </div>
              <Truck className="w-10 h-10 opacity-90" />
            </div>
          </div>

          {/* Retail Sales */}
          <div
            className={`${cardColors[2]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm opacity-80">Retail Sales</p>
                <h3
                  ref={retailRef}
                  style={{ fontSize: `${retailFont}px` }}
                  className="font-bold mt-2"
                >
                  ₹{retailTotal.toFixed(2)}
                </h3>
              </div>
              <ShoppingCart className="w-10 h-10 opacity-90" />
            </div>
          </div>

          {/* Products */}
          <div
            className={`${cardColors[3]} rounded-2xl p-6 shadow-lg flex flex-col justify-between`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm opacity-80">Products</p>
                <h3
                  ref={productRef}
                  style={{ fontSize: `${productFont}px` }}
                  className="font-bold mt-2"
                >
                  {productCount}
                </h3>
                <p className="text-sm opacity-70">In inventory</p>
              </div>
              <Package className="w-10 h-10 opacity-90" />
            </div>
          </div>
        </div>

        {/* Low Stock Alert */}
        {lowStockProducts.length > 0 && (
          <div className="bg-gradient-to-r from-red-600 to-red-800 text-white rounded-2xl p-6 shadow-lg flex flex-col justify-between mt-10">
            <div>
              <p className="text-sm opacity-80">Low Stock Alert</p>
              <ul className="mt-2 space-y-1 text-sm">
                {lowStockProducts.map((p) => (
                  <li key={p.id}>
                    ⚠️ {p.product}{" "}
                    <span className="opacity-75">({p.category})</span> –{" "}
                    {p.stock} left
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Quick Actions */}
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-12">
            Quick Actions
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 justify-center">
            {[
              {
                label: "Add Product",
                icon: <PlusCircle className="w-6 h-6" />,
                to: "/admin/wholesale",
              },
              {
                label: "New Wholesale Bill",
                icon: <FilePlus className="w-6 h-6" />,
                to: "/admin/billing",
              },
              {
                label: "New Retail Bill",
                icon: <ShoppingCart className="w-6 h-6" />,
                to: "/admin/retail",
              },
              {
                label: "Customer Bills",
                icon: <UserPlus className="w-6 h-6" />,
                to: "/admin/retaildetails",
              },
              {
                label: "Workers Bills",
                icon: <Users className="w-6 h-6" />,
                to: "/admin/workers-bills",
              },
            ].map((action, idx) => (
              <Link
                key={idx}
                to={action.to}
                className="no-underline bg-white rounded-xl p-6 shadow-md border hover:shadow-lg transition flex flex-col items-center gap-3"
              >
                <div className="bg-gray-100 p-4 rounded-full">
                  {action.icon}
                </div>
                <span className="text-sm font-semibold text-gray-800">
                  {action.label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
